import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const rootSx: SvgIconProps['sx'] = {
  color: 'inherit',
  '& path': { fill: 'currentColor', color: 'inherit' },
}

export const IconProjects: React.FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={[rootSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    {...props}
  >
    <path
      d="M16.1699 2C18.0399 2 19.5098 3.46027 19.5098 5.28027V18.6504C19.5096 20.5202 17.9898 21.9902 16.1699 21.9902H7.83984C5.97005 21.9902 4.50021 20.4702 4.5 18.6504V5.33984C4.50008 3.46997 6.01996 2.00008 7.83984 2H16.1699ZM7.83984 3.87012C7.07991 3.87021 6.42969 4.52033 6.42969 5.28027V18.5996C6.42969 19.3696 7.07991 20.0097 7.83984 20.0098H16.1602C16.9201 20.0097 17.5703 19.3596 17.5703 18.5996L17.5801 18.5898V5.28027C17.5801 4.51027 16.9299 3.87012 16.1699 3.87012H7.83984ZM13.0596 14.2598C13.4096 14.2598 13.7597 14.55 13.7598 14.96C13.7598 15.37 13.4696 15.6602 13.0596 15.6602H8.71973C8.30987 15.66 8.01953 15.3699 8.01953 14.96C8.01955 14.5501 8.30989 14.2599 8.71973 14.2598H13.0596ZM15.4004 11.3799C15.7503 11.3801 16.0996 11.6702 16.0996 12.0801C16.0996 12.4899 15.8102 12.7801 15.4004 12.7803H8.66016C8.25018 12.7803 7.96 12.49 7.95996 12.0801C7.95996 11.6701 8.25016 11.3799 8.66016 11.3799H15.4004ZM15.4004 8.50977C15.7503 8.50998 16.0996 8.80013 16.0996 9.20996C16.0996 9.61983 15.8102 9.90998 15.4004 9.91016H8.66016C8.25016 9.91016 7.95996 9.61996 7.95996 9.20996C7.95998 8.79998 8.25017 8.50977 8.66016 8.50977H15.4004ZM15.4004 5.69043C15.7502 5.69064 16.0994 5.97998 16.0996 6.38965C16.0996 6.79952 15.8102 7.08966 15.4004 7.08984H8.66016C8.25016 7.08984 7.95996 6.79965 7.95996 6.38965C7.96013 5.97983 8.25027 5.69043 8.66016 5.69043H15.4004Z"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
)
